export enum STORE_NAMES {
  AUTH = 'AuthStore',
  USER = 'UserStore',
  WORKSPACE = 'WorkspaceStore',
  FILTERS = 'FiltersStore',
  FILTERS_UI = 'FiltersUIStore',
  CROSS_FILTERS = 'CrossFiltersStore',
  WORKSPACE_SELECTION = 'WorkspaceSelectionStore',
  REPORT_TASKS = 'ReportTasksStore',
  DTC_AUDIENCE_TASKS = 'DtcAudienceTasksStore',
}
